import { Fragment } from 'react';
import { NavLink } from 'react-router';
import { ChevronRightIcon } from '@/components/icons';
import { useRouteConfig } from '@/screens/routeConfigs/useRouteConfig';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';

export const Breadcrumb = ({
  currentPageTitle,
}: {
  currentPageTitle?: string;
}) => {
  const breadcrumbs = useBreadcrumbs(useRouteConfig(), {
    excludePaths: ['/'],
  });

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div className="px-8 py-6 border-b border-gray-100 shadow-sm">
      <div className="flex gap-1 title-h5 items-center flex-wrap">
        {breadcrumbs.map(({ pathname, breadcrumb }, i) => {
          return i === breadcrumbs.length - 1 && !currentPageTitle ? (
            <span key={pathname}>{breadcrumb}</span>
          ) : (
            <Fragment key={pathname}>
              <NavLink to={pathname} className="text-gray-500">
                {breadcrumb}
              </NavLink>
              <ChevronRightIcon className="shrink-0" />
            </Fragment>
          );
        })}
        {currentPageTitle && <span>{currentPageTitle}</span>}
      </div>
    </div>
  );
};
